import type {PropsWithChildren} from 'react'
import {ActionList} from '@primer/react'
import {
  Tabs as PrimerTabContainer,
  useTab,
  useTabList,
  useTabPanel,
  type TabListProps,
  type TabPanelProps,
  type TabProps,
  type TabsProps,
} from '@primer/react/experimental'
import styles from './Tabs.module.css'

export function Tabs(props: PropsWithChildren<TabsProps>) {
  return (
    <PrimerTabContainer {...props}>
      <div className={styles.tabContainer}>{props.children}</div>
    </PrimerTabContainer>
  )
}

export function TabList(props: PropsWithChildren<TabListProps>) {
  const {tabListProps} = useTabList<HTMLUListElement>({...props, 'aria-orientation': 'vertical'})
  return (
    <ActionList className={styles.tabList} {...tabListProps}>
      {props.children}
    </ActionList>
  )
}

export function Tab(
  props: PropsWithChildren<
    TabProps & {
      icon?: React.ReactElement
    }
  >,
) {
  const {tabProps} = useTab(props)

  return (
    <ActionList.Item active={String(tabProps['aria-selected']) === 'true'} {...tabProps}>
      {props.children}
      {props.icon && <ActionList.LeadingVisual>{props.icon}</ActionList.LeadingVisual>}
    </ActionList.Item>
  )
}

export function TabPanel(props: PropsWithChildren<TabPanelProps>) {
  const {tabPanelProps} = useTabPanel(props)
  if (!props.value || tabPanelProps.hidden) {
    return null
  }

  return (
    <div className={styles.tabPanel} {...tabPanelProps}>
      {props.children}
    </div>
  )
}

try{ Tabs.displayName ||= 'Tabs' } catch {}
try{ TabList.displayName ||= 'TabList' } catch {}
try{ Tab.displayName ||= 'Tab' } catch {}
try{ TabPanel.displayName ||= 'TabPanel' } catch {}